import {
  Autocomplete,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useUser } from 'src/components/hooks/useUser';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';
import { useGetCountriesQuery, useGetSitesQuery, useLazyGetStudiesQuery } from 'src/services/Utils';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useAppDispatch } from 'src/store/hooks';
import { clearMessage } from 'src/store/Message';

const AddIssueForm: React.FunctionComponent<any> = ({
  setCreateData,
  createData,
  updateData,
  edit,
  setUpdateData,
  serverity,
  issue,
  category,
  initialState,
  submit,
  componentRef,
  atError,
  daError,
  duError,
  ddError,
  iaError,
  issueLogPermissions,
  decisionUserList,
  actionUsersList,
  currentIssueLevel,
  setDisableSubmit,
  setWarningMessage
}) => {
  const value = null;
  const { preferedFormatForDatePicker, userPreferedDateFormat } = usePreferedDateFormat();
  const dateFormat = userPreferedDateFormat.toUpperCase();
  const [studyRefetch, { data: studyData, isError: studyIsError }] = useLazyGetStudiesQuery();
  useEffect(() => {
    studyRefetch();
  }, []);
  const {
    data: countryData,
    isError: countryIsError,
    refetch: countryget
  } = useGetCountriesQuery(edit ? updateData.study_id : createData.study_id);
  const {
    data: siteData,
    isError: siteIsError,
    refetch: siteget
  } = useGetSitesQuery({
    currentStudy: edit ? updateData.study_id : createData.study_id,
    currentCountry: edit ? updateData.country : createData.country
  });
  const [studylist, setStudylist] = useState<any>([]);
  const [countrylist, setCountrylist] = useState<any>([]);
  const [sitelist, setSitelist] = useState<any>([]);
  const [actionDateIssue, setActionDateIssue] = useState<boolean>(false);
  const [decisionDateIssue, setDecisionDateIssue] = useState<boolean>(false);
  const [occuranceDateIssue, setOccuranceDateIssue] = useState<boolean>(false);
  const [irbReportDateIssue, setIrbReportDateIssue] = useState<boolean>(false);
  const [reportDateIssue, setReportDateIssue] = useState<boolean>(false);
  const [acDueDateIssue, setAcDueDateIssue] = useState<boolean>(false);
  const [dcDueDateIssue, setDcDueDateIssue] = useState<boolean>(false);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
      }
    }
  };
  const dispatchApp = useAppDispatch();
  useEffect(() => {
    if (studyData && !studyIsError) {
      const tempArr = studyData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setStudylist(tempArr);
    } else {
      setStudylist([]);
    }
  }, [studyData, studyIsError]);
  useEffect(() => {
    if (countryData && !countryIsError) {
      const tempArr = countryData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setCountrylist(tempArr);
    } else {
      setCountrylist([]);
    }
  }, [countryData, countryIsError]);
  useEffect(() => {
    if (siteData && !siteIsError) {
      const tempArr = siteData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setSitelist(tempArr);
    } else {
      setSitelist([]);
    }
  }, [siteData, siteIsError]);

  const actionAssignedTo = updateData.action_assigned_to.length <= 0;
  const decisionAssignedTo = updateData.decision_assigned_to.length <= 0;
  const issueCreatedUser = updateData.created_by;
  const { user, email } = useUser();
  const currentUserWithEmail = `${user} (${email})`;
  const filterActionUsers = actionAssignedTo
    ? updateData.action_assigned_to
    : updateData.action_assigned_to.filter((name: string) => name === currentUserWithEmail);
  const filterDecisionUsers = decisionAssignedTo
    ? updateData.decision_assigned_to
    : updateData.decision_assigned_to.filter((name: string) => name === currentUserWithEmail);

  const handleChange = (event: any) => {
    dispatchApp(clearMessage());
    setDisableSubmit(false);
    setWarningMessage(true);
    if (edit) {
      setUpdateData({ ...updateData, [event.target.name]: event.target.value });
    } else {
      setCreateData({ ...createData, [event.target.name]: event.target.value });
    }
  };

  /**  functionality for toggling the checkbox */
  const handleCheckBoxChanged = (event: any) => {
    dispatchApp(clearMessage());
    setDisableSubmit(false);
    if (edit) {
      if (event.target.checked) {
        setUpdateData({ ...updateData, [event.target.name]: 'Yes' });
      } else {
        if (event.target.name === 'reported_irb') {
          setUpdateData({ ...updateData, reported_irb: 'No', date_irb: null });
        } else if (event.target.name === 'action_req') {
          setUpdateData({
            ...updateData,
            [event.target.name]: 'No',
            action_des: '',
            action_taken: '',
            action_assigned_to: [],
            action_due: null,
            action_completion_dt: null
          });
        } else {
          setUpdateData({
            ...updateData,
            [event.target.name]: 'No',
            decision: '',
            decision_update: '',
            decision_assigned_to: [],
            decision_due_dt: null,
            decision_comp_dt: null
          });
        }
      }
    } else {
      if (event.target.checked) {
        setCreateData({ ...createData, [event.target.name]: 'Yes' });
      } else {
        if (event.target.name === 'reported_irb') {
          setCreateData({ ...createData, reported_irb: 'No', date_irb: null });
        } else if (event.target.name === 'action_req') {
          setCreateData({
            ...createData,
            [event.target.name]: 'No',
            action_des: '',
            action_taken: '',
            action_assigned_to: [],
            action_due: null,
            action_completion_dt: null
          });
        } else {
          setCreateData({
            ...createData,
            [event.target.name]: 'No',
            decision: '',
            decision_update: '',
            decision_assigned_to: [],
            decision_due_dt: null,
            decision_comp_dt: null
          });
        }
      }
    }
  };
  /** End */

  const [initialStudy, setStudyInitial] = useState(false);
  const [initialCountry, setCountryInitial] = useState(false);
  useEffect(() => {
    if (initialStudy) {
      if (updateData.study_id === null) {
        updateData.country = null;
        updateData.site_id = null;
        setCountrylist([]);
        setSitelist([]);
      } else if (updateData.study_id) {
        updateData.country = null;
        updateData.site_id = null;
        countryget();
      }
      if (createData.study_id === null) {
        createData.country = null;
        createData.site_id = null;
        setCountrylist([]);
        setSitelist([]);
      } else if (createData.study_id) {
        initialState.study_id = null;
        createData.country = null;
        createData.site_id = null;
        countryget();
      }
    }
    setStudyInitial(true);
  }, [createData.study_id, updateData.study_id]);
  useEffect(() => {
    if (initialCountry) {
      if (createData.country === null) {
        createData.site_id = null;
      } else if (createData.country !== initialState.country) {
        createData.site_id = null;
        siteget();
      }
      if (updateData.country === null) {
        updateData.site_id = null;
        setSitelist([]);
      } else if (updateData.country !== initialState.country) {
        updateData.site_id = null;
        siteget();
      }
    }
    setCountryInitial(true);
  }, [createData.country, updateData.country]);

  const getServerDateOrInvalid = (newDateValue: any) => {
    return String(newDateValue.$d) !== 'Invalid Date'
      ? moment(newDateValue.$d).format(SERVER_DATE_FORMAT)
      : String(newDateValue.$d);
  };

  return (
    <Grid container item rowSpacing={2} columnSpacing={5}>
      <Grid item xs={12}>
        <FormControl variant="standard" fullWidth>
          <TextField
            disabled
            name="issue_no"
            label="Issue Number"
            variant="standard"
            value={edit ? updateData.issue_no : createData.issue_no}
            inputProps={{
              maxLength: 100
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl
          variant="standard"
          fullWidth
          error={edit ? (submit ? updateData.study_id === null : false) : submit ? createData.study_id === null : false}
        >
          <Autocomplete
            disabled={edit || currentIssueLevel == 'SITE'}
            disablePortal
            id="combo-box-demo"
            options={studylist}
            onChange={(_: any, newValue: any | null) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, study_id: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, study_id: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.study_id : createData.study_id}
            renderInput={params => (
              <TextField
                error={submit ? createData.study_id === null : false}
                {...params}
                label="Study"
                className="alignFields"
              />
            )}
          />
          {(edit ? (submit ? updateData.study_id === null : false) : submit ? createData.study_id === null : false) && (
            <FormHelperText>Required</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="standard" fullWidth>
          <Autocomplete
            disabled={edit || currentIssueLevel == 'SITE'}
            disablePortal
            id="combo-box-demo"
            options={countrylist}
            onChange={(_: any, newValue: any | null) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, country: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, country: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.country : createData.country}
            renderInput={params => <TextField {...params} label="Country" className="alignFields" />}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="standard" fullWidth>
          <Autocomplete
            disabled={edit || currentIssueLevel == 'SITE'}
            disablePortal
            id="combo-box-demo"
            options={sitelist}
            onChange={(_: any, newValue: any | null) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, site_id: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, site_id: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.site_id : createData.site_id}
            renderInput={params => <TextField {...params} label="Site" className="alignFields" />}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="standard" fullWidth>
          <TextField
            disabled={
              edit
                ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther)
                : false
            }
            name="subject_id"
            label="Subject ID"
            variant="standard"
            value={edit ? updateData.subject_id : createData.subject_id}
            onChange={handleChange}
            inputProps={{
              maxLength: 50
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl
          variant="standard"
          fullWidth
          error={
            edit
              ? submit
                ? updateData.category === undefined
                : false
              : submit
              ? createData.category === undefined
              : false
          }
        >
          <InputLabel required id="demo-simple-select-standard-label">
            Category
          </InputLabel>
          <Select
            MenuProps={menuProps}
            disabled={
              edit
                ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther)
                : false
            }
            labelId="demo-simple-select-standard-label"
            name="category"
            value={edit ? updateData.category : createData.category}
            onChange={handleChange}
            label="Issue Number"
          >
            {category?.map((item: any) => {
              return (
                <MenuItem key={item.id} value={item.code_list_value}>
                  {item.code_list_value}
                </MenuItem>
              );
            })}
          </Select>
          {(edit
            ? submit
              ? updateData.category === undefined
              : false
            : submit
            ? createData.category === undefined
            : false) && <FormHelperText>Required</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl
          variant="standard"
          fullWidth
          error={
            edit
              ? submit
                ? updateData.severity === undefined
                : false
              : submit
              ? createData.severity === undefined
              : false
          }
        >
          <InputLabel required id="demo-simple-select-standard-label">
            Severity
          </InputLabel>
          <Select
            disabled={
              edit
                ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther)
                : false
            }
            labelId="demo-simple-select-standard-label"
            name="severity"
            value={edit ? updateData.severity : createData.severity}
            onChange={handleChange}
            label="Severity"
          >
            {serverity?.map((item: any) => {
              return (
                <MenuItem key={item.id} value={item.code_list_value}>
                  {`${item.code_list_value_code}-${item.code_list_value}`}
                </MenuItem>
              );
            })}
          </Select>
          {(edit
            ? submit
              ? updateData.severity === undefined
              : false
            : submit
            ? createData.severity === undefined
            : false) && <FormHelperText>Required</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl
          variant="standard"
          fullWidth
          error={
            edit
              ? submit
                ? updateData.issue_class === undefined
                : false
              : submit
              ? createData.issue_class === undefined
              : false
          }
        >
          <InputLabel required id="demo-simple-select-standard-label">
            Issue Class
          </InputLabel>
          <Select
            disabled={
              edit
                ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther)
                : false
            }
            labelId="demo-simple-select-standard-label"
            name="issue_class"
            value={edit ? updateData.issue_class : createData.issue_class}
            onChange={handleChange}
            label="Issue Class"
          >
            {issue?.map((item: any) => {
              return (
                <MenuItem key={item.id} value={item.code_list_value}>
                  {item.code_list_value}
                </MenuItem>
              );
            })}
          </Select>
          {(edit
            ? submit
              ? updateData.issue_class === undefined
              : false
            : submit
            ? createData.issue_class === undefined
            : false) && <FormHelperText>Required</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControlLabel
          disabled={
            edit
              ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                (updateData.created_by !== user && !issueLogPermissions.updateOther)
              : false
          }
          control={<Checkbox name="reported_irb" />}
          label="Reported to IRB/IEC?"
          sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
          checked={
            edit
              ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
              : createData.reported_irb === 'Yes' || createData.reported_irb === true
          }
          onChange={handleCheckBoxChanged}
        />
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.reported_irb === 'No' ||
                  updateData.reported_irb === undefined ||
                  updateData.reported_irb === false
                : createData.reported_irb === 'No' || createData.reported_irb === undefined
            }
            inputFormat={dateFormat}
            label="IRB Report Date"
            value={preferedFormatForDatePicker(edit ? updateData.date_irb : createData.date_irb)}
            onChange={(newValue: any) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, date_irb: null });
                setUpdateData({ ...updateData, date_irb: null });
              }
              if (newValue !== null) {
                setCreateData({
                  ...createData,
                  date_irb: getServerDateOrInvalid(newValue)
                });
                setUpdateData({
                  ...updateData,
                  date_irb: getServerDateOrInvalid(newValue)
                });
              }
              //IRB report date inline error message
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setIrbReportDateIssue(true);
              } else {
                setIrbReportDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                error={
                  (edit
                    ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                      ? submit
                        ? updateData.date_irb === undefined || updateData.date_irb === null
                        : false
                      : false
                    : createData.reported_irb === 'Yes' || createData.reported_irb === true
                    ? submit
                      ? createData.date_irb === undefined || createData.date_irb === null
                      : false
                    : false) || irbReportDateIssue
                }
                helperText={
                  (
                    edit
                      ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                        ? submit
                          ? updateData.date_irb === undefined || updateData.date_irb === null
                          : false
                        : false
                      : createData.reported_irb === 'Yes' || createData.reported_irb === true
                      ? submit
                        ? createData.date_irb === undefined || createData.date_irb === null
                        : false
                      : false
                  )
                    ? 'Required'
                    : irbReportDateIssue
                    ? 'Invalid Date'
                    : ''
                }
                required={
                  edit
                    ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                    : createData.reported_irb === 'Yes' || createData.reported_irb === true
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther)
                : false
            }
            inputFormat={dateFormat}
            label="Date of Issue Occurrence"
            value={preferedFormatForDatePicker(edit ? updateData.dt_occur : createData.dt_occur)}
            onChange={(newValue: any) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, dt_occur: null });
                setUpdateData({ ...updateData, dt_occur: null });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, dt_occur: getServerDateOrInvalid(newValue) });
                setUpdateData({ ...updateData, dt_occur: getServerDateOrInvalid(newValue) });
              } else {
                setCreateData({ ...createData, dt_occur: null });
                setUpdateData({ ...updateData, dt_occur: null });
              }
              //occurance date inline error
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setOccuranceDateIssue(true);
              } else {
                setOccuranceDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                required
                {...params}
                error={
                  (edit
                    ? submit
                      ? updateData.dt_occur === undefined || updateData.dt_occur === null
                      : false
                    : submit
                    ? createData.dt_occur === undefined || createData.dt_occur === null
                    : false) ||
                  occuranceDateIssue ||
                  iaError
                }
                helperText={
                  (
                    edit
                      ? submit
                        ? updateData.dt_occur === undefined || updateData.dt_occur === null
                        : false
                      : submit
                      ? createData.dt_occur === undefined || createData.dt_occur === null
                      : false
                  )
                    ? 'Required'
                    : occuranceDateIssue
                    ? 'Invalid Date'
                    : ''
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            required
            disabled={
              edit
                ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther)
                : false
            }
            error={
              edit
                ? submit
                  ? updateData.issue === undefined || updateData.issue === ''
                  : false
                : submit
                ? createData.issue === undefined || createData.issue === ''
                : false
            }
            helperText={
              (
                edit
                  ? submit
                    ? updateData.issue === undefined || updateData.issue === ''
                    : false
                  : submit
                  ? createData.issue === undefined || createData.issue === ''
                  : false
              )
                ? 'Required'
                : ''
            }
            name="issue"
            label="Issue"
            variant="standard"
            value={edit ? updateData.issue : createData.issue}
            onChange={handleChange}
            inputProps={{
              maxLength: 2000
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            inputFormat={dateFormat}
            disabled={
              edit
                ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther)
                : false
            }
            label="Date of Issue Reporting"
            value={preferedFormatForDatePicker(edit ? updateData.dt_report : createData.dt_report)}
            minDate={value}
            onChange={(newValue: any) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, dt_report: null });
                setUpdateData({ ...updateData, dt_report: null });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, dt_report: getServerDateOrInvalid(newValue) });
                setUpdateData({ ...updateData, dt_report: getServerDateOrInvalid(newValue) });
              } else {
                setCreateData({ ...createData, dt_report: null });
                setUpdateData({ ...updateData, dt_report: null });
              }
              //Date of Report report date inline error message
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setReportDateIssue(true);
              } else {
                setReportDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                required
                {...params}
                error={
                  (edit
                    ? submit
                      ? updateData.dt_report === undefined || updateData.dt_report === null
                      : false
                    : submit
                    ? createData.dt_report === undefined || createData.dt_report === null
                    : false) || reportDateIssue
                }
                helperText={
                  (
                    edit
                      ? submit
                        ? updateData.dt_report === undefined || updateData.dt_report === null
                        : false
                      : submit
                      ? createData.dt_report === undefined || createData.dt_report === null
                      : false
                  )
                    ? 'Required'
                    : reportDateIssue
                    ? 'Invalid date'
                    : ''
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          disabled={
            edit
              ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                (updateData.created_by !== user && !issueLogPermissions.updateOther)
              : false
          }
          control={<Checkbox name="action_req" />}
          label="Action Required?"
          checked={
            edit ? updateData.action_req === 'Yes' || updateData.action_req === true : createData.action_req === 'Yes'
          }
          onChange={handleCheckBoxChanged}
          sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            name="action_des"
            label="Action Description"
            variant="standard"
            value={edit ? updateData.action_des : createData.action_des}
            inputProps={{
              maxLength: 2000
            }}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} mt={2}>
        <FormControl fullWidth>
          <TextField
            required={edit ? updateData.action_completion_dt : createData.action_completion_dt}
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  ((filterActionUsers.length > 0 ? false : true) &&
                    issueCreatedUser !== user &&
                    !issueLogPermissions.updateOther) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            error={
              (edit
                ? updateData.action_taken
                  ? false
                  : submit
                  ? updateData.action_completion_dt
                    ? true
                    : false
                  : false
                : createData.action_taken
                ? false
                : submit
                ? createData.action_completion_dt
                  ? true
                  : false
                : false) || atError
            }
            helperText={
              (
                edit
                  ? updateData.action_taken
                    ? false
                    : submit
                    ? updateData.action_completion_dt
                      ? true
                      : false
                    : false
                  : createData.action_taken
                  ? false
                  : submit
                  ? createData.action_completion_dt
                    ? true
                    : false
                  : false
              )
                ? 'Required'
                : ''
            }
            name="action_taken"
            label="Action Taken"
            variant="standard"
            value={edit ? updateData.action_taken : createData.action_taken}
            inputProps={{
              maxLength: 2000
            }}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} mb={2} mt={1}>
        <FormControl variant="standard" fullWidth>
          <InputLabel
            id="demo-simple-select-standard-label"
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
          />
          <Autocomplete
            className="customNamePicker"
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            disablePortal
            multiple
            id="demo-simple-select-standard-label"
            options={actionUsersList}
            autoComplete
            // for filtering the autocomplete list with atleast 3 characters
            filterOptions={(options: Array<any>, state: any) => {
              let filteredOption: any = [];
              filteredOption = options.filter((item: any) => {
                if (state?.inputValue.length >= 3) {
                  if (
                    item.toLowerCase() === state?.inputValue.toLowerCase() ||
                    item.toLowerCase().includes(state?.inputValue.toLowerCase())
                  ) {
                    return item;
                  }
                }
              });
              return filteredOption;
            }}
            renderTags={(value: readonly any[], getTagProps) =>
              value.map((option: any, index: number) => (
                <div key={index} className="autoCompleteChip">
                  <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                </div>
              ))
            }
            onChange={(event, newValue) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (edit) {
                setUpdateData({ ...updateData, action_assigned_to: newValue });
              } else {
                setCreateData({ ...createData, action_assigned_to: newValue });
              }
            }}
            value={edit ? updateData.action_assigned_to : createData.action_assigned_to}
            renderInput={params => (
              <TextField
                error={false}
                {...params}
                label="Action Assigned To"
                placeholder="Please enter initial 3 characters of the name for user assignment"
              />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            inputFormat={dateFormat}
            label="Action Due Date"
            value={preferedFormatForDatePicker(edit ? updateData.action_due : createData.action_due)}
            onChange={(newValue: any) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, action_due: null });
                setUpdateData({ ...updateData, action_due: null });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, action_due: getServerDateOrInvalid(newValue) });
                setUpdateData({ ...updateData, action_due: getServerDateOrInvalid(newValue) });
              }
              //Action Due date inline error message
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setAcDueDateIssue(true);
              } else {
                setAcDueDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                error={acDueDateIssue ? 'Invalid Date' : ''}
                helperText={acDueDateIssue ? 'Invalid Date' : ''}
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  ((filterActionUsers.length > 0 ? false : true) &&
                    issueCreatedUser !== user &&
                    !issueLogPermissions.updateOther) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            disableFuture
            inputFormat={dateFormat}
            label="Date of Action completion"
            value={preferedFormatForDatePicker(
              edit ? updateData.action_completion_dt : createData.action_completion_dt
            )}
            minDate={value}
            onChange={(newValue: any) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({
                  ...createData,
                  action_completion_dt: null
                });
                setUpdateData({
                  ...updateData,
                  action_completion_dt: null
                });
              }
              if (newValue !== null) {
                setCreateData({
                  ...createData,
                  action_completion_dt: getServerDateOrInvalid(newValue)
                });
                setUpdateData({
                  ...updateData,
                  action_completion_dt: getServerDateOrInvalid(newValue)
                });
                //action date inline error message
                if (
                  String(newValue.$d) !== 'Invalid Date' &&
                  new Date(newValue).toLocaleDateString('en-CA') > new Date().toLocaleDateString('en-CA')
                ) {
                  setActionDateIssue(true);
                } else {
                  setActionDateIssue(false);
                }
              } else {
                //restrict action date auto reload
                setCreateData({
                  ...createData,
                  action_completion_dt: null
                });
                setUpdateData({
                  ...updateData,
                  action_completion_dt: null
                });
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                required={edit ? updateData.action_taken : createData.action_taken}
                error={
                  (edit
                    ? updateData.action_completion_dt
                      ? false
                      : submit
                      ? updateData.action_taken
                        ? true
                        : false
                      : false
                    : createData.action_completion_dt
                    ? false
                    : submit
                    ? createData.action_taken
                      ? true
                      : false
                    : false) ||
                  actionDateIssue ||
                  daError
                }
                helperText={
                  (
                    edit
                      ? updateData.action_completion_dt
                        ? false
                        : submit
                        ? updateData.action_taken
                          ? true
                          : false
                        : false
                      : createData.action_completion_dt
                      ? false
                      : submit
                      ? createData.action_taken
                        ? true
                        : false
                      : false
                  )
                    ? 'Required'
                    : actionDateIssue
                    ? 'Invalid or Future date entered'
                    : ''
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          disabled={
            edit
              ? (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                (updateData.created_by !== user && !issueLogPermissions.updateOther)
              : false
          }
          control={<Checkbox name="decision_req" />}
          label="Decisions Required?"
          checked={
            edit
              ? updateData.decision_req === 'Yes' || updateData.decision_req === true
              : createData.decision_req === 'Yes'
          }
          onChange={handleCheckBoxChanged}
          sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            name="decision"
            label="Decisions"
            variant="standard"
            value={edit ? updateData.decision : createData.decision}
            onChange={handleChange}
            inputProps={{
              maxLength: 2000
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            required={edit ? updateData.decision_comp_dt : createData.decision_comp_dt}
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  ((filterDecisionUsers.length > 0 ? false : true) &&
                    issueCreatedUser !== user &&
                    !issueLogPermissions.updateOther) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            error={
              (edit
                ? updateData.decision_update
                  ? false
                  : submit
                  ? updateData.decision_comp_dt
                    ? true
                    : false
                  : false
                : createData.decision_update
                ? false
                : submit
                ? createData.decision_comp_dt
                  ? true
                  : false
                : false) || duError
            }
            helperText={
              (
                edit
                  ? updateData.decision_update
                    ? false
                    : submit
                    ? updateData.decision_comp_dt
                      ? true
                      : false
                    : false
                  : createData.decision_update
                  ? false
                  : submit
                  ? createData.decision_comp_dt
                    ? true
                    : false
                  : false
              )
                ? 'Required'
                : ''
            }
            name="decision_update"
            label="Decision Update"
            variant="standard"
            value={edit ? updateData.decision_update : createData.decision_update}
            onChange={handleChange}
            inputProps={{
              maxLength: 2000
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} mb={2} mt={1}>
        <FormControl variant="standard" fullWidth>
          <InputLabel
            id="demo-simple-select-standard-label"
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
          >
            {/* Decision Assigned To */}
          </InputLabel>
          <Autocomplete
            className="customNamePicker"
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            disablePortal
            multiple
            id="demo-simple-select-standard-label"
            options={decisionUserList}
            autoComplete
            // for filtering the autocomplete list with atleast 3 characters
            filterOptions={(options: Array<any>, state: any) => {
              let filteredOption: any = [];
              filteredOption = options.filter((item: any) => {
                if (state?.inputValue.length >= 3) {
                  if (
                    item.toLowerCase() === state?.inputValue.toLowerCase() ||
                    item.toLowerCase().includes(state?.inputValue.toLowerCase())
                  ) {
                    return item;
                  }
                }
              });
              return filteredOption;
            }}
            renderTags={(value: readonly any[], getTagProps) =>
              value.map((option: any, index: number) => (
                <div key={index} className="autoCompleteChip">
                  <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                </div>
              ))
            }
            onChange={(event, newValue) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (edit) {
                setUpdateData({ ...updateData, decision_assigned_to: newValue });
              } else {
                setCreateData({ ...createData, decision_assigned_to: newValue });
              }
            }}
            value={edit ? updateData.decision_assigned_to : createData.decision_assigned_to}
            renderInput={params => (
              <TextField
                error={false}
                {...params}
                label="Decision Assigned To"
                placeholder="Please enter initial 3 characters of the name for user assignment"
              />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  (!issueLogPermissions.update && !issueLogPermissions.updateOther) ||
                  (updateData.created_by !== user && !issueLogPermissions.updateOther) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            inputFormat={dateFormat}
            label="Decision Due Date"
            value={preferedFormatForDatePicker(edit ? updateData.decision_due_dt : createData.decision_due_dt)}
            minDate={value}
            onChange={(newValue: any) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, decision_due_dt: null });
                setUpdateData({
                  ...updateData,
                  decision_due_dt: null
                });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, decision_due_dt: getServerDateOrInvalid(newValue) });
                setUpdateData({
                  ...updateData,
                  decision_due_dt: getServerDateOrInvalid(newValue)
                });
              }
              //Decision Due date inline error message
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setDcDueDateIssue(true);
              } else {
                setDcDueDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                error={dcDueDateIssue ? 'Invalid Date' : ''}
                helperText={dcDueDateIssue ? 'Invalid Date' : ''}
                name="decision_due_dt"
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            ref={componentRef}
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  ((filterDecisionUsers.length > 0 ? false : true) &&
                    issueCreatedUser !== user &&
                    !issueLogPermissions.updateOther) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            disableFuture
            inputFormat={dateFormat}
            label="Date of Decision completion"
            value={preferedFormatForDatePicker(edit ? updateData.decision_comp_dt : createData.decision_comp_dt)}
            minDate={value}
            onChange={(newValue: any) => {
              dispatchApp(clearMessage());
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({
                  ...createData,
                  decision_comp_dt: null
                });
                setUpdateData({
                  ...updateData,
                  decision_comp_dt: null
                });
              }
              if (newValue !== null) {
                setCreateData({
                  ...createData,
                  decision_comp_dt: getServerDateOrInvalid(newValue)
                });
                setUpdateData({
                  ...updateData,
                  decision_comp_dt: getServerDateOrInvalid(newValue)
                });
                //decision date inline error message
                if (new Date(newValue).toLocaleDateString('en-CA') > new Date().toLocaleDateString('en-CA')) {
                  setDecisionDateIssue(true);
                } else {
                  setDecisionDateIssue(false);
                }
              } else {
                //restrict decision date auto reload
                setCreateData({
                  ...createData,
                  decision_comp_dt: null
                });
                setUpdateData({
                  ...updateData,
                  decision_comp_dt: null
                });
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                required={edit ? updateData.decision_update : createData.decision_update}
                error={
                  (edit
                    ? updateData.decision_comp_dt
                      ? false
                      : submit
                      ? updateData.decision_update
                        ? true
                        : false
                      : false
                    : createData.decision_comp_dt
                    ? false
                    : submit
                    ? createData.decision_update
                      ? true
                      : false
                    : false) ||
                  decisionDateIssue ||
                  ddError
                }
                helperText={
                  (
                    edit
                      ? updateData.decision_comp_dt
                        ? false
                        : submit
                        ? updateData.decision_update
                          ? true
                          : false
                        : false
                      : createData.decision_comp_dt
                      ? false
                      : submit
                      ? createData.decision_update
                        ? true
                        : false
                      : false
                  )
                    ? 'Required'
                    : decisionDateIssue
                    ? 'Invalid or Future date entered'
                    : ''
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};

export default AddIssueForm;
